// [ai] Dossier link grammar. `rec:ID?t=SEC&e=SEC` plays a recording, `note:UUID?at=OFFSET&len=N` opens a note. Pages also
// carry /play/ID?t= and the hash form #rec=ID&t= / #note=ID&at= (the player's own deep link).
export type RecLink = { kind: "rec"; id: string; t: number; e: number | null };
export type NoteLink = { kind: "note"; id: string; at: number; len: number };
export type Link = RecLink | NoteLink;
function num(v: string | undefined | null): number | null { if (v == null || v === "") return null; const n = Number(v); return Number.isFinite(n) ? n : null; }
function params(q: string | undefined): Record<string, string> { const o: Record<string, string> = {}; for (const part of (q || "").split("&")) { if (!part) continue; const [k, v = ""] = part.split("="); try { o[decodeURIComponent(k!)] = decodeURIComponent(v); } catch { o[k!] = v; } } return o; }
export function parseLink(href: string | null | undefined): Link | null {
  if (!href) return null;
  let m = /^rec:([^?#]+)(?:\?([^#]*))?/.exec(href) || /^\/play\/([^?#/]+)(?:\?([^#]*))?/.exec(href);
  if (m) { const p = params(m[2]); return { kind: "rec", id: decodeURIComponent(m[1]!), t: num(p.t) ?? 0, e: num(p.e) }; }
  m = /^note:([^?#]+)(?:\?([^#]*))?/.exec(href);
  if (m) { const p = params(m[2]); return { kind: "note", id: decodeURIComponent(m[1]!), at: num(p.at) ?? 0, len: num(p.len) ?? 0 }; }
  return null;
}
export function buildLink(l: Link): string {
  if (l.kind === "rec") { const q = [`t=${+(+l.t).toFixed(2)}`]; if (l.e != null) q.push(`e=${+(+l.e).toFixed(2)}`); return `rec:${l.id}?${q.join("&")}`; }
  const q = [`at=${l.at | 0}`]; if (l.len) q.push(`len=${l.len | 0}`); return `note:${l.id}?${q.join("&")}`;
}
export function parseHash(hash: string | null | undefined): Link | null {
  const p = params((hash || "").replace(/^#/, ""));
  if (p.rec) return { kind: "rec", id: p.rec, t: num(p.t) ?? 0, e: num(p.e) };
  if (p.note) return { kind: "note", id: p.note, at: num(p.at) ?? 0, len: num(p.len) ?? 0 };
  return null;
}
export function toHash(l: Link): string { return l.kind === "rec" ? `#rec=${encodeURIComponent(l.id)}&t=${+(+l.t).toFixed(1)}` : `#note=${encodeURIComponent(l.id)}&at=${l.at | 0}`; }
